import UpcomingDonations from "../Admin/DonorManagement/UpcomingDonations";
import { Helmet } from "react-helmet";
import TokenService from "../../Services/Token.service";
function UpComingDonations() {
    return (
        <>
            <Helmet>
                <title>DonorX | Upcoming Donations</title>
            </Helmet>
            <div className="el-middle-wrapper">
                <h2 className="el-title">Upcoming Donations</h2>
                <div className="el-card-content">
                    <div className="my-5 el-bg-table">
                        <UpcomingDonations donorId={TokenService.getUserId()} userType={"donor"} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default UpComingDonations;